import React from 'react';
import { renderComponent } from 'utils/commonUtils';
import AttendanceAuditList from './AttendanceAuditList';

const AttendanceAudit = () => {
  return renderComponent(<AttendanceAuditList />);
};

export default AttendanceAudit;
